<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24">
    <ng-container *ngIf="pickMode === 'defaultAudiences' && alreadySelectedAudiences.length">
        <h3 class="mb-12">{{ 'GENERAL.LABEL.SELECTED' | translate }}</h3>
        <mat-chip-set class="chip-list mb-24 wrap">
            <mat-chip class="chip" [removable]="removable" (removed)="removeFromList(item, i)" *ngFor="let item of alreadySelectedAudiences; let i = index">
                {{ item.valueToShow }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div class="p-16 bg-gray-100">
        <app-audience-filter
            #audienceList
            [defaultSettingPicker]="pickMode === 'defaultAudiences'"
            [defaultSettingExperienceId]="defaultSettingExperienceId"
            [excludeAutomaticAudiences]="true"
            [preSelectUnassigned]="isUnassignedAudienceSelected"
            [alreadySelectedAudiences]="alreadySelectedAudiences"
            (choosenAudiences)="loadAudienceList($event)"
            (addedToList)="onAudienceFilterListChange($event)"
            [isSingleSelect]="pickMode !== 'defaultAudiences'"
        ></app-audience-filter>
    </div>
</div>

<div class="pt-0 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.SAVE'"
        (onClick)="onConfirm()"
        [disabled]="pickMode === 'defaultAudiences' ? !hasDefaultAudiencePickSelection : !selectedAudience"
    ></app-flat-button>
</div>
